(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('MonitoringRuleTemporaryExclusion', MonitoringRuleTemporaryExclusion);

    MonitoringRuleTemporaryExclusion.$inject = ['$resource'];

    function MonitoringRuleTemporaryExclusion($resource) {
        return $resource('api/monitoring-rule-temporary-exclusions/:id', {}, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'save': {
                method: 'POST'
            },
            'update': {
                method: 'PUT'
            },
            'delete': {
                method: 'DELETE'
            }
        });
    }
})();
